/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import { Link } from 'react-router-dom'

type Props = {
    link: string
    route?: true | false
    rounded: 'sm' | 'lg'
    arrow: true | false
    length: 'sm' | 'lg'
}

const Secondary: React.FC<Props> = ({ link, route, rounded, arrow, children, length }) => {
    return (
        <>
            {route === true ?
                <Link to={link} className={(rounded === 'sm' ? 'rounded-md' : 'rounded-full') + (length === 'sm' ? ' px-7 ' : ' px-12') + ' bg-transparent hover:bg-gray-100 border border-gray-100 py-2.5 px-7 text-gray-100 hover:text-gray-900 font-medium transtion' + (arrow === true && ' flex items-center')}>
                    {children}
                    {arrow === true &&
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                        </svg>
                    }
                </Link>
            :
                <a href={link} className={(rounded === 'sm' ? 'rounded-md' : 'rounded-full') + (length === 'sm' ? ' px-7 ' : ' px-12') + ' bg-transparent hover:bg-gray-100 border border-gray-100 py-2.5 px-7 text-gray-100 hover:text-gray-900 font-medium transtion' + (arrow === true && ' flex items-center')}>
                    {children}
                    {arrow === true &&
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                        </svg>
                    }
                </a>
            }
        </>
    )
}

export default Secondary